import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import RefreshAnimationIcon from 'assets/images/Refetch/RefreshAnimationIcon.svg';

export const RefreshAnimation: React.FC = () => {
  return (
    <SvgIcon
      data-testid="button loader"
      sx={{
        animation: `spin 1s linear infinite`,
      }}
    >
      <RefreshAnimationIcon />
    </SvgIcon>
  );
};
